"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var web_base_1 = require("@tencent/web-base");
var andr_download_1 = tslib_1.__importDefault(require("./andr-download"));
var download_button_1 = require("../../download-button");
var download_1 = require("../launch/download");
var config_context_1 = require("../../_util/config-context");
var index_1 = require("../../download-button/_util/index");
var LaunchComponent = function (props) {
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = tslib_1.__read((0, react_1.useState)(false), 2), shouldShowGuide = _a[0], setShowGuide = _a[1];
    var launchFunc = props.launchFunc, _b = props.from, from = _b === void 0 ? '' : _b, _c = props.beaconReport, beaconReport = _c === void 0 ? function () { return void 0; } : _c;
    (0, react_1.useEffect)(function () {
        // 灯塔数据上报请参考文档：https://docs.qq.com/sheet/DQnhTdkRFUGRUWXdP?tab=612q78
        beaconReport('web_launchapp_page_null_null_null_null_explore', { fromSource: from });
    }, []);
    var handleDownloadVooVMeeting = function () {
        beaconReport('web_launchapp_page_voovbutton_null_null_null_click', { fromSource: from });
        (0, download_1.downloadVooVMeeting)();
    };
    var retryLaunch = function () {
        beaconReport('web_launchapp_page_retrybutton_null_null_null_click', { fromSource: from });
        launchFunc();
    };
    var renderSubDesc = function () {
        if ((0, web_base_1.isMobile)() && ((0, web_base_1.isWeChat)() || (0, web_base_1.isWxWork)())) {
            return (react_1.default.createElement("div", null, t('若您已安装了腾讯会议，或点击下载按钮后无反应，请点击右上角，用浏览器打开')));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null,
                t('若您已安装了腾讯会议，请'),
                react_1.default.createElement("span", { className: "".concat(classPrefix, "-link"), onClick: retryLaunch }, t('点击此处'))),
            react_1.default.createElement("div", null, t('如果浏览器对话框弹出，请点击【打开腾讯会议】按钮'))));
    };
    if (web_base_1.isServer) {
        // next项目用到这个组件，有一些判断 userAgent的，会出现闪动
        // http://tapd.oa.com/20375092/bugtrace/bugs/view?bug_id=1020375092094925961
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "".concat(classPrefix, "-defbg") }),
        react_1.default.createElement("div", { className: "".concat(classPrefix, "-launch") },
            react_1.default.createElement("div", { className: "".concat(classPrefix, "-logo") },
                react_1.default.createElement("div", { className: "".concat(classPrefix, "-logo-img") }),
                react_1.default.createElement("div", { className: "".concat(classPrefix, "-logo-txt") }, t('该页面会唤起腾讯会议')),
                react_1.default.createElement("div", { className: "".concat(classPrefix, "-desc") },
                    react_1.default.createElement("div", null, t('若无法正常跳转请先点击【立即下载】按钮')),
                    renderSubDesc()),
                react_1.default.createElement("div", { className: "".concat(classPrefix, "-btn-content") },
                    react_1.default.createElement(download_button_1.DownloadButton, { onClick: function () {
                            beaconReport('web_launchapp_page_downloadbutton_null_null_null_click', { fromSource: from });
                            (0, index_1.handleClick)(function () { return setShowGuide(true); });
                        } }))),
            react_1.default.createElement("div", { className: "".concat(classPrefix, "-voov-download-container") },
                react_1.default.createElement("div", { id: "voov-download-tips1", className: "".concat(classPrefix, "-voov-text") }, t('如果您使用非中国大陆地区手机号码，请点击前往')),
                react_1.default.createElement("div", { id: "voov-download-tips2", className: "".concat(classPrefix, "-voov-link"), onClick: handleDownloadVooVMeeting }, t('下载 VooV Meeting')))),
        shouldShowGuide && react_1.default.createElement(andr_download_1.default, { closeAndrGuide: function () { return setShowGuide(false); } })));
};
exports.default = LaunchComponent;
//# sourceMappingURL=launch-component.js.map